import styled from "styled-components";
import {
  DefaultParagraphMediumFactory,
  DefaultTitleLargeFactory,
} from "../../Habitacional/core/Typograph/Typograph.Style";

export const PQOSectionContainer = styled.section(({ theme }) => ({
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",
  borderBottom: `4px solid ${theme.color.line.medium}`,

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const PQOSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "inherit",
  gap: "24px",

  [theme.breakpoint.lg()]: {
    alignItems: "flex-start",
  },
}));

export const PQOSectionHeader = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
}));

export const PQOSectionTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const PQOSectionDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphMediumFactory({ theme }),
}));
